import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  DialogTitle,
  TextField,
  Stack,
  SvgIcon,
  CircularProgress,
} from "@mui/material";
import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import applyAiText from "../helpers/applyAiText";
import { ReactComponent as MySvg } from "../images/Google_Gemini_icon_2025.svg";

export default function AiDialog(props) {
  const [aiTextParameters, setAiTextParameters] = React.useState(
    "Please revise the following text to make it sound more professional, formal, and suitable for a business context. Just provide the revised text.",
  );
  const [originalText, setOriginalText] = React.useState(props.text);
  const [resultsTest, setResultsTest] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const onGenerateText = async () => {
    setIsLoading(true);
    const result = await applyAiText(
      aiTextParameters,
      originalText,
      props.characterLimit,
    );
    setResultsTest(result);
    setIsLoading(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"lg"}
      open={props.isOpenAI}
      onClose={props.onCloseAI}
      scroll={"paper"}
    >
      <DialogTitle style={{ paddingTop: 0, paddingBottom: 0 }}>
        {"Use Gemini to Improve text"}
      </DialogTitle>
      <DialogContent>
        {/* <DialogContentText>{"Google Gemini 3"}</DialogContentText> */}

        <Stack
          style={{ paddingTop: 14 }}
          direction="column"
          spacing={3}
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl style={{ paddingTop: 0 }} fullWidth>
            <TextField
              id="standard-multiline-flexible"
              label="Gemini input parameters"
              fullWidth
              value={aiTextParameters}
              onChange={(e) => setAiTextParameters(e.target.value)}
              multiline
              rows={5}
              size="small"
              variant="outlined"
              error={aiTextParameters.length < 20 ? true : false}
              helperText={
                aiTextParameters.length < 20
                  ? "Gemini input parameters must be at least 20 characters long."
                  : ""
              }
            />
          </FormControl>
          <FormControl style={{ paddingTop: 0 }} fullWidth>
            <TextField
              id="standard-multiline-flexible"
              label="Original Text"
              fullWidth
              value={originalText}
              onChange={(e) => setOriginalText(e.target.value)}
              multiline
              rows={4}
              error={originalText.length < 20 ? true : false}
              helperText={
                originalText.length < 20
                  ? "Original Text must be at least 20 characters long."
                  : ""
              }
              size="small"
              variant="outlined"
            />
          </FormControl>
          {isLoading ? (
            <CircularProgress color="inherit" />
          ) : (
            <Button
              startIcon={<SvgIcon component={MySvg} inheritViewBox />}
              disabled={
                originalText.length < 20 || aiTextParameters.length < 20
                  ? true
                  : false
              }
              onClick={onGenerateText}
              fullWidth
              variant="contained"
            >
              Generate Text
            </Button>
          )}

          {resultsTest.length > 0 && (
            <FormControl style={{ paddingTop: 0 }} fullWidth>
              <TextField
                id="standard-multiline-flexible"
                label="AI Generated Text"
                fullWidth
                value={resultsTest}
                onChange={(e) => setResultsTest(e.target.value)}
                multiline
                rows={4}
                size="small"
                variant="outlined"
              />
            </FormControl>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button startIcon={<ArrowBackIcon />} onClick={props.onCloseAI}>
          Cancel
        </Button>

        <Button
          startIcon={<SaveIcon />}
          variant="contained"
          disabled={resultsTest.length === 0 ? true : false}
          //   props.isLoading
          //     ? true
          //     : props.formErrorMessage.length === 0
          //       ? false
          //       : true
          // }
          onClick={() => {
            props.onChange({
              target: { name: props.fieldName, value: resultsTest },
            });
            props.onCloseAI();
          }}
        >
          Use AI Text
        </Button>
      </DialogActions>
    </Dialog>
  );
}
